export class Price {
  baseAmount: number;
  actualAmount: number;

  constructor(data: { baseAmount: number; actualAmount: number }) {
    this.baseAmount = data.baseAmount;
    this.actualAmount = data.actualAmount;
  }

  get discountedAmount() {
    return this.baseAmount - this.actualAmount;
  }
}
